import { stepFiles } from "@/server/debtor"
const state = {
  infoList: [],
  curIndex: null,         // 当前cur
  copyIndex: []      //拷贝 index
}
const mutations = {
  SET_INFO_KEY: (state, data) => {     //初始设置infoList
    const { key, value } = data;
    state[key] = value
  },
  REMOVE_INFO: (state, data) => {
    state.infoList = []
    state.curIndex = null;
    state.copyIndex = []
  }
}
const actions = {
  async reMove({ commit }, data) {      //关闭清除污染
    return new Promise((resolve, reject) => {
      commit("REMOVE_INFO")
      resolve()
    })
  },
  async setInfokey({ commit }, data) {
    commit("SET_INFO_KEY", data)
  },
  async copydel({ commit, state, dispatch }, data) {      //
    let infoList = JSON.parse(JSON.stringify(state.infoList))
    infoList.splice(data.index, 1)
    let newCopy = state.copyIndex.filter(ele => {
      return ele != data.index
    })
    dispatch("setInfokey", { key: "infoList", value: infoList })
    dispatch("setInfokey", { key: "copyIndex", value: newCopy })
    if (state.curIndex == data.index) {
      dispatch("setInfokey", { key: "curIndex", value: state.curIndex - 1 })
      data.index = data.index - 1
    }
    return new Promise((resolve, reject) => {
      dispatch("FormData", data).then(e => {
        resolve(e)
      })
    })
  },
  async FormData({ commit, state }, data) {
    const { index, formKey, valkey } = data
    let getFile = (id, rid) => {     //公共 调用
      return new Promise((resolve, reject) => {
        stepFiles({ step_id: id, rid: rid }).then(e => {
          resolve(e.list)
        })
      })
    }
    return new Promise((resolve, reject) => {
      let infoList = state.infoList[index][valkey]
      let isArr = Array.isArray(infoList);
      let newform = isArr ? [] : {}
      if (isArr) {
        infoList.map(element => {
          let Item = {}
          formKey.map(ele => {
            Item[ele] = element[ele]
          })
          newform.push(Item)
        })
        let getAll = async () => {        //循环抛请求 
          let result = await Promise.all(infoList.map(ele => { return getFile(ele.step_id, ele.id) }))
          return result;
        }
        if (valkey === "cpws") {
          stepFiles({ step_id: state.infoList[index].id }).then(e => {
            resolve({ files: e.list, list: newform })
          })
        } else {
          getAll().then(result => {     //初始状态进行请求
            result.map((ele, index) => {
              newform[index].files = ele
            })
            resolve(newform)
          })
        }
      } else {
        formKey.map(ele => {
          newform[ele] = infoList[ele]
        })
        stepFiles({ step_id: state.infoList[index][valkey].step_id }).then(e => {
          newform.files = e.list
          resolve(newform)
        })
      }

    })
  },
  async see({ commit, state, dispatch }, data) {    //  
    const { index, formKey, valkey } = data
    if (state.curIndex == index) return false;
    dispatch("setInfokey", { key: "curIndex", value: index })
    return new Promise((resolve, reject) => {
      dispatch("FormData", data).then(e => {
        resolve(e)
      })
    })
  },
  async see1({ commit, state, dispatch }, data) {    //  
    const { index, formKey, valkey } = data
    // if (state.curIndex == index) return false;
    dispatch("setInfokey", { key: "curIndex", value: index })
    return new Promise((resolve, reject) => {
      dispatch("FormData", data).then(e => {
        resolve(e)
      })
    })
  },
  async addNew({ commit, state, dispatch }, data) {
    let infoList = JSON.parse(JSON.stringify(state.infoList)), copyIndex = JSON.parse(JSON.stringify(state.copyIndex));
    infoList.push(data)
    await dispatch("setInfokey", { key: "infoList", value: infoList })
    await dispatch("setInfokey", { key: "curIndex", value: infoList.length - 1 })
    copyIndex.push(infoList.length - 1)
    await dispatch("setInfokey", { key: "copyIndex", value: copyIndex })
    return new Promise((resolve, reject) => {
      resolve(infoList.length - 1)
    })
  },
  async scroll({ commit, state, dispatch }, data) {
    let curIndex = state.curIndex
    return new Promise((resolve, reject) => {
      let index;
      if (data.type == "next") {
        index = curIndex == state.infoList.length - 1 ? 0 : curIndex + 1;
      } else {
        index = curIndex == 0 ? state.infoList.length - 1 : curIndex - 1
      }
      resolve(index)
    })
    //DisForm.curIndex==DisForm.infoList.length-1?0:DisForm.curIndex++;see(Index)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
